export default __webpack_public_path__ + "static/media/3_bottom.6330fa88.jpg";